import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Lock, Unlock, Trash2, Edit2 } from 'lucide-react';
import { formatDate } from './adminUtils';

export function UsersTab({ users, handleUserRole, openEditUser, handleToggleBan, handleDeleteUser }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[480px]">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="text-left px-4 py-3 text-slate-600 font-semibold">Kullanıcı</th>
              <th className="text-left px-4 py-3 text-slate-600 font-semibold hidden md:table-cell">Email</th>
              <th className="text-left px-4 py-3 text-slate-600 font-semibold">Rol</th>
              <th className="text-left px-4 py-3 text-slate-600 font-semibold hidden sm:table-cell">Katılım</th>
              <th className="text-right px-4 py-3 text-slate-600 font-semibold">İşlem</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {users.map(u => (
              <tr key={u._id} data-testid={`admin-user-${u._id}`} className="hover:bg-slate-50 transition-colors">
                <td className="px-4 py-3 max-w-[180px]">
                  <div className="font-medium text-slate-800 truncate">{u.display_name || u.username}</div>
                  <div className="text-xs text-slate-400 truncate">@{u.username}{u.is_banned && <span className="ml-2 text-red-500 font-medium">YASAKLI</span>}</div>
                </td>
                <td className="px-4 py-3 text-slate-500 hidden md:table-cell truncate max-w-[220px]">{u.email}</td>
                <td className="px-4 py-3">
                  <Select value={u.role} onValueChange={val => handleUserRole(u._id, val)}>
                    <SelectTrigger className="w-24 sm:w-32 h-7 text-xs" data-testid={`user-role-select-${u._id}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="user">Üye</SelectItem>
                      <SelectItem value="moderator">Moderatör</SelectItem>
                      <SelectItem value="admin">Admin</SelectItem>
                    </SelectContent>
                  </Select>
                </td>
                <td className="px-4 py-3 text-slate-400 text-xs hidden sm:table-cell">{formatDate(u.created_at)}</td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-1">
                    <button onClick={() => openEditUser(u)} className="p-1.5 rounded-lg text-slate-500 hover:bg-slate-100" data-testid={`user-edit-${u._id}`} title="Düzenle"><Edit2 className="w-3.5 h-3.5" /></button>
                    <button onClick={() => handleToggleBan(u)} className={`p-1.5 rounded-lg ${u.is_banned ? 'text-emerald-600 bg-emerald-50' : 'text-amber-600 hover:bg-amber-50'}`} data-testid={`user-ban-${u._id}`} title={u.is_banned ? 'Yasağı kaldır' : 'Yasakla'}>{u.is_banned ? <Unlock className="w-3.5 h-3.5" /> : <Lock className="w-3.5 h-3.5" />}</button>
                    <button onClick={() => handleDeleteUser(u)} className="p-1.5 rounded-lg text-red-500 hover:bg-red-50" data-testid={`user-delete-${u._id}`} title="Sil"><Trash2 className="w-3.5 h-3.5" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
